type QueryParams = Record<string, string | undefined>

const API_ORIGINS_BY_FRONTEND_HOST: Record<string, string> = {
  'schedule-viewer-dashboard.pages.dev': 'https://analytics-dashboard-worker.jaelre.workers.dev',
}

function getApiOrigin(): string {
  const configuredUrl = import.meta.env.VITE_API_BASE_URL?.trim()

  if (configuredUrl) {
    let parsedUrl: URL
    try {
      parsedUrl = new URL(configuredUrl)
    } catch {
      throw new Error('VITE_API_BASE_URL must be an absolute Worker origin URL')
    }

    if (parsedUrl.pathname !== '/' || parsedUrl.search || parsedUrl.hash) {
      throw new Error('VITE_API_BASE_URL must be a Worker origin URL without path, query, or hash')
    }

    return parsedUrl.origin
  }

  const mappedApiOrigin = API_ORIGINS_BY_FRONTEND_HOST[window.location.hostname]
  if (mappedApiOrigin) {
    return mappedApiOrigin
  }

  return window.location.origin
}

export function buildApiUrl(endpoint: string, params?: QueryParams): string {
  if (!endpoint.startsWith('/api/')) {
    throw new Error(`API endpoint must start with /api/: ${endpoint}`)
  }

  const url = new URL(endpoint, getApiOrigin())

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value)
      }
    })
  }

  return url.toString()
}
